module.exports = __webpack_public_path__ + "assets/nodataImg.3a74e9be.svg";